<template>
    <div v-if="search == false" class="group-region" @click="changeCollapse(view.label)">
        <span class="timezone-title-select">{{ view.label }}</span>
        <div class="timezone-structure" v-show="view.collapse == true">
            <div class="timezones" :class="{ 'checked': zones.selected }" v-for="(zones, key) in view.options" :key="key" @click="saveData(zones.value)">
                {{ zones.text }} <span class="time">{{ getTime(zones.value) }}</span>
            </div>
        </div>
    </div>
    <div v-else-if="search == true" class="timezone-structure">
        <div class="timezones" @click="saveData(view.value)">{{ view.text }} <span class="time">{{ getTime(view.value) }}</span></div>
    </div>
</template>

<script>
export default {
    name: "timezoneSelect",
    props: {
        view: {
            type: Object,
            required: true
        },
        saveTimezone: {
            type: Function,
            required: true
        },
        closeCollapses: {
            type: Function,
            required: true
        },
        search: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    data() {
        return {
        }
    },
    methods: {
        saveData(timezone) {
            this.saveTimezone(timezone)
        },
        changeCollapse(label) {
            this.closeCollapses(label)
        },
        getTime(val) {
            return typeof moment != 'undefined' && typeof moment.tz == 'function' ? moment().tz(val).format('LT') : ''
        }

    }
}
</script>

<style lang="scss" scoped>
.group-region {
    transition: background-color .2s;
    width: 100%;
    min-height: 2rem;
    height: auto;
    background-color: #f8fafd;

    border-top: 1px solid #e8e8e8;

    display: flex;
    flex-direction: column;

    position: relative;

    .timezone-title-select {
        font-family: 'Muli';
        font-family: 1.5rem;
        font-weight: 500;

        color: #2C3E50;

        padding: .8rem;

        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.timezone-structure {
    width: 100%;
    top: 2rem;

    display: flex;
    flex-direction: column;
}

.timezones {
    transition: height .2s;
    height: 2.3rem;
    color: #434343;
    background-color: #FFF;

    border-top: 1px solid #e8e8e8;

    font-family: 'Muli';
    font-weight: 500;
    text-align: left;

    padding: 0 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .time {
        width: auto;
        min-width: 4.3rem;
        text-align: end;
        color: #b0b0b0 !important;
        font-size: 12px !important;
    }
}

.checked {
    background-color: #f0f3f5 !important;
}

.timezones:hover {
    transition: background-color .2s;
    background-color: #0080FCFF;
    color: #fff;
    .time {
        color: #fff !important;
    }
}
.group-region:hover {
    transition: background-color .2s;
    background-color: #0080FCFF;
    .timezone-title-select {
        color: #fff;
    }
}
.d-block {
    display: block;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/lib/timezoneSelect.vue